import { render, staticRenderFns } from "./legendFrozen.vue?vue&type=template&id=39cba5a2&scoped=true"
import script from "./legendFrozen.vue?vue&type=script&lang=ts"
export * from "./legendFrozen.vue?vue&type=script&lang=ts"
import style0 from "./legendFrozen.vue?vue&type=style&index=0&id=39cba5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cba5a2",
  null
  
)

export default component.exports